import { useState, useEffect } from "react";
import { INTEGRATION_TRADE_CODE_FOR_AUTHORIZATION } from "lib/constants";
import { getAPICall } from "lib/callApi";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "utils/Loader";

function OauthCb() {
  const navigate = useNavigate();
  const location = useLocation();
  const integrationHandler = location?.pathname?.split?.("/oauth/cb/")?.[1];
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");

  useEffect(() => {
    if (code && integrationHandler) {
      (async () => {
        const result = await getAPICall(
          `${INTEGRATION_TRADE_CODE_FOR_AUTHORIZATION}/${integrationHandler}${window.location.search}`,
          true
        );
        if (result.status === 200) {
          setShouldRedirect(true);
        }
      })();
    }
  }, [code, integrationHandler]);

  useEffect(() => {
    if (shouldRedirect) {
      navigate("/settings?selectedTab=integrations");
    }
  }, [shouldRedirect]);

  return <Loader loading />;
}

export default OauthCb;
